import { ChevronDown, Instagram, MessageCircle } from 'lucide-react';
import { useLanguage } from '../contexts/LanguageContext';

const socialLinks = [
  {
    icon: Instagram,
    label: 'Instagram',
    url: 'https://www.instagram.com/martin.senk_/',
    color: 'hover:text-pink-400'
  },
  {
    icon: MessageCircle,
    label: 'WhatsApp',
    url: 'https://api.whatsapp.com/send?phone=420775648863',
    color: 'hover:text-green-400'
  }
];

const Hero = () => {
  const { t } = useLanguage();
  
  return (
    <section id="hero" className="relative min-h-screen flex items-center justify-center section-padding">
      <div className="container-max text-center">
        <div className="max-w-4xl mx-auto hero-content">
          {/* Social Links */}
          <div className="mb-4 animate-fade-in-down" style={{ animationDelay: '0.1s' }}>
            <div className="flex flex-wrap justify-center items-center gap-3 md:gap-4 md:flex-nowrap">
              {socialLinks.map((social, index) => (
                <a
                  key={index}
                  href={social.url}
                  target="_blank"
                  rel="noopener noreferrer"
                  className={`w-10 h-10 md:w-12 md:h-12 rounded-full bg-gray-800/50 backdrop-blur-sm border border-gray-700/50 flex items-center justify-center text-gray-400 ${social.color} transition-all duration-300 hover:bg-gray-700/50 hover:border-primary-500/50 hover:scale-110 group animate-fade-in`}
                  style={{ animationDelay: `${0.2 + index * 0.05}s` }}
                >
                  <social.icon className="w-5 h-5 md:w-6 md:h-6 group-hover:scale-110 transition-transform" />
                </a>
              ))}
            </div>
          </div>

          {/* Hero Image */}
          <div className="mb-8 animate-scale-in" style={{ animationDelay: '0.2s' }}>
            <img
              src="/martuvod.webp"
              alt="Martin Šenk - CrossFit Trainer"
              className="w-64 h-64 md:w-80 md:h-80 object-cover object-top rounded-full mx-auto shadow-2xl border-4 border-primary-500/50"
              loading="eager"
              width="640"
              height="963"
            />
          </div>

          {/* Main Heading */}
          <h1 
            className="text-5xl md:text-7xl font-bold mb-6 text-shadow animate-fade-in-up"
            style={{ animationDelay: '0.3s' }}
          >
            Martin <span className="text-primary-400">Šenk</span>
          </h1>

          {/* Subtitle */}
          <p 
            className="text-xl md:text-2xl text-gray-300 mb-8 animate-fade-in-up"
            style={{ animationDelay: '0.4s' }}
          >
            {t.hero.subtitle}
          </p>

          {/* CTA Button */}
          <div className="animate-fade-in-up" style={{ animationDelay: '0.5s' }}>
            <a
              href="#contact"
              className="btn-primary inline-block"
            >
              {t.hero.cta}
            </a>
          </div>
        </div>
      </div>

      {/* Scroll Indicator */}
      <div 
        className="absolute bottom-8 left-1/2 transform -translate-x-1/2 animate-fade-in"
        style={{ animationDelay: '0.8s' }}
      >
        <div className="animate-bounce-slow">
          <ChevronDown className="w-8 h-8 text-primary-400" />
        </div>
      </div>
    </section>
  );
};

export default Hero;
